import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import * as validate from './FormValidation';
import {scrollToFirstError} from '../helpers/ReduxFormScrollToError';
import {Button, Divider, Icon, Alert} from 'antd';



const FormInstallateur = props => {
    const { handleSubmit, pristine, reset, submitting, back } = props;
    return (
        <form onSubmit={handleSubmit}>
            <div className="content">
                <Divider orientation={"left"}>Ausführender Installateur</Divider>
                <Alert
                    message="Hinweis"
                    description="
                        Wegen des Termins für Bauwasser und zur Herstellung des Hausanschlusses setzen Sie sich bitte telefonisch mit uns unter 08781/9413-0 in Verbindung.
                    "
                    type="warning"
                    showIcon
                />
                <Alert
                    message="Beachte"
                    description="
                       Lt. § 11 Abs. 4 Wasserabgabesatzung dürfen Installationsarbeiten an der Anlage nur durch den Zweckverband oder durch ein zugelassenes Installationsunternehmen erfolgen, das in ein gültiges Installateurverzeichnis eingetragen ist. Die Installationen sind gemäß DIN 1988 und den jeweiligen Vorschriften und (DVGW-) Richtlinien auszuführen. Vor Einbau des Wasserzählers ist die Fertigstellungsanzeige des Installateurs beim Zweckverband einzureichen (siehe Anlage bzw. Homepage).
                        "
                    type="warning"
                    showIcon
                />
                <br/><br/>

                <Field
                    name="Inst_Installateur"
                    label="Ausführender, im Installationsverzeichnis eingetragener Installateur  (Falls noch nicht klar, bitte „noch nicht bekannt“ eintragen und nachmelden):"
                    type="text"
                    required
                    component={validate.renderField}
                    validate={[validate.required, validate.minLength2]}
                    
                />

                <Field
                    name="Inst_Mail"
                    label="Email-Adresse Installateur:"
                    type="text"
                    component={validate.renderField}
                    alidate={[validate.email]}
                    
                />

                <Field
                    name="Inst_Verzeichnis"
                    label="Eingetragen im Installateurverzeichnis von:"
                    type="text"
                    component={validate.renderField}
                    
                />

                <Field
                    name="Inst_Ausweis_Nr"
                    label="Ausweis Nr.:"
                    type="text"
                    component={validate.renderField}
                    
                />


                <div className={"right-container"}>
                    <Button className={"pull-right"} type={"primary"} htmlType={"submit"} disabled={submitting}>Weiter <Icon type={"right"}/></Button>
                    <Button type={"default"} htmlType={"button"} onClick={back}><Icon type={"left"}/> Zurück</Button>
                </div>
            </div>
        </form>
    );
};



let FormInstallateurRedux = reduxForm({
    form: 'auftragform',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    onSubmitFail: (errors) => scrollToFirstError(errors),
})(FormInstallateur);



export default FormInstallateurRedux;



// WEBPACK FOOTER //
// ./src/components/FormInstallateur.js